import React from "react";
import SVGComponent from "../../../../SVGComponent";
import AccountSection from "../AccountSection";
import ICONS from "../../../../../../assets/Icons";

/**
 * ------------------------------------------------------------------
 * SourceDestinationCard Component
 * ------------------------------------------------------------------
 
 *
 * @typedef {Object} AccountData
 * @property {string} [label] - Main title of the account section
 * @property {string} [subtitle] - Secondary text under title
 * @property {string} [bottomTitle] - Bottom row primary text
 * @property {string} [bottomSubtitle] - Bottom row secondary text
 * @property {string} [ifsc] - IFSC code used to display bank logo
 * @property {string} [dividerColor] - Color of internal divider line
 *
 *
 * @param {Object} props
 *
 * @param {AccountData} props.sourceData
 * Object containing details for the source account.
 *
 * @param {AccountData} props.destinationData
 * Object containing details for the destination account.
 *
 * @param {string} [props.lineColor="var(--text-secondary)"]
 * Color of the horizontal divider lines between sections.
 *
 * @param {string} [props.bgColor="var(--card_bg)"]
 * Background color applied to both account sections.
 *
 * @returns {JSX.Element}
 */

const SourceDestinationCard = ({
  sourceData,
  destinationData,
  lineColor = "var(--text-secondary)",
  bgColor = "var(--card_bg)",
}) => {
  return (
    <div className="w-full flex flex-col gap-gap-xs mb-margin-sm last:mb-margin-base">
      <AccountSection
        bgColor={bgColor}
        title={sourceData?.label}
        subtitle={sourceData?.subtitle}
        bottomTitle={sourceData?.bottomTitle}
        bottomSubtitle={sourceData?.bottomSubtitle}
        ifsc={sourceData?.ifsc}
        dividerColor={sourceData?.dividerColor}
      />

      <div className="flex items-center w-full px-padding-md gap-gap-sm">
        <div
          className="flex-1 border-t"
          style={{ borderColor: lineColor }}
        />

        <SVGComponent
          url={ICONS?.ARROW_DOWN_GREY}
          width="var(--icon-sm)"
          height="var(--icon-sm)"
          color="var(--text-primary)"
        />

        <div
          className="flex-1 border-t"
          style={{ borderColor: lineColor }}
        />
      </div>

      <AccountSection
        bgColor={bgColor}
        title={destinationData?.label}
        subtitle={destinationData?.subtitle}
        bottomTitle={destinationData?.bottomTitle}
        bottomSubtitle={destinationData?.bottomSubtitle}
        ifsc={destinationData?.ifsc}
        dividerColor={sourceData?.dividerColor}
      />
    </div>
  );
};

export default SourceDestinationCard;
